import React from "react";
const Diamonds = props => {

    return (
      <>
        <div className="diamonds" style={{'maxWidth': props.maxWidth || '100%'}}>
          <img src={`/img/rombo-${ props.theme === 'dark' ? 'negativo' : 'positivo' }.svg `} className="diamond" />
          <img src={`/img/rombo-${ props.theme === 'dark' ? 'negativo' : 'positivo' }.svg `} className="diamond" />
          <img src={`/img/rombo-${ props.theme === 'dark' ? 'negativo' : 'positivo' }.svg `} className="diamond" />
          <img src={`/img/rombo-${ props.theme === 'dark' ? 'negativo' : 'positivo' }.svg `} className="diamond x:hide l:show" />
        </div>
      </>
    )
  }
  
  export default Diamonds
  